<template>
    <div v-if="ui.settings.zoom.enabled" class="flex items-center gap-1">
        <button
            dusk="zoom-out"
            :class="[
                'flex h-[34px] w-[34px] cursor-pointer items-center justify-center rounded-md border border-theme-border bg-transparent p-0 text-sm font-normal text-theme-text transition-colors duration-150',
                'hover:bg-black/[0.04] focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 high-contrast-dark:hover:bg-white/[0.06] dark:hover:bg-white/[0.06]',
            ]"
            :title="localizations[lang].tooltips.zoomOut"
            :aria-label="localizations[lang].tooltips.zoomOut"
            @click="decreaseZoom"
        >
            <template v-if="isPdf">
                <svg
                    aria-hidden="true"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                >
                    <line x1="5" y1="12" x2="19" y2="12" />
                </svg>
            </template>
            <span v-else>A</span>
        </button>

        <button
            :class="[
                'min-w-9 cursor-default border-none bg-transparent px-0.5 py-1 text-center text-[11px] font-normal tabular-nums text-theme-secondary-text opacity-50 transition-all duration-150 focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2',
                {
                    'cursor-pointer text-theme-accent opacity-100 hover:underline': !isOriginal,
                },
            ]"
            :title="isOriginal ? '' : localizations[lang].tooltips.zoomReset"
            :aria-label="zoomResetLabel"
            @click="resetZoom"
        >
            {{ zoomPercentage }}%
        </button>

        <button
            dusk="zoom-in"
            :class="[
                'flex h-[34px] w-[34px] cursor-pointer items-center justify-center rounded-md border border-theme-border bg-transparent p-0 font-normal text-theme-text transition-colors duration-150',
                'hover:bg-black/[0.04] focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 high-contrast-dark:hover:bg-white/[0.06] dark:hover:bg-white/[0.06]',
                isPdf ? 'text-sm' : 'text-lg',
            ]"
            :title="localizations[lang].tooltips.zoomIn"
            :aria-label="localizations[lang].tooltips.zoomIn"
            @click="increaseZoom"
        >
            <template v-if="isPdf">
                <svg
                    aria-hidden="true"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                >
                    <line x1="12" y1="5" x2="12" y2="19" />
                    <line x1="5" y1="12" x2="19" y2="12" />
                </svg>
            </template>
            <span v-else>A</span>
        </button>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
    name: 'ComponentsZoomControl',

    computed: {
        ...mapState(['ui', 'localizations', 'lang', 'settings']),
        ...mapGetters(['isPdf']),

        zoomPercentage() {
            if (this.isPdf) {
                return Math.round(this.ui.settings.zoom.select.scale * 100);
            }

            return Math.round(this.settings.fontSize * 100);
        },

        isOriginal() {
            if (this.isPdf) {
                return this.ui.settings.zoom.select.scale === 1;
            }
            return this.settings.fontSize === 1;
        },

        zoomResetLabel() {
            if (this.isOriginal) {
                return `${this.localizations[this.lang].tooltips.zoomIn} ${this.zoomPercentage}%`;
            }
            return this.localizations[this.lang].tooltips.zoomReset;
        },
    },

    methods: {
        decreaseZoom() {
            this.$bus.$emit('zoomOut');
        },
        increaseZoom() {
            this.$bus.$emit('zoomIn');
        },
        resetZoom() {
            if (!this.isOriginal) {
                if (this.isPdf) {
                    this.$bus.$emit('zoomSelect', { type: 'page-fit' });
                } else {
                    this.$bus.$emit('zoomReset');
                }
            }
        },
    },
};
</script>
